import React from "react";

// Plain page in the cached skin's background while the admin v2 chunk loads
// (no spinner, no flash of the public site colours). It sits in the main
// bundle, so it imports nothing from the v2 admin: the two backgrounds and
// the cache key are copied here (BootFallback.test.js keeps them in sync with
// tokens.js and skinCache.js).
export const BOOT_BG = { noir: "#0F0E0C", "after-dark": "#120D1C" };
export const BOOT_SKIN_KEY = "djr.adminV2.skin";

export const bootBackground = () => {
  let skin = "noir";
  try {
    const saved = window.localStorage.getItem(BOOT_SKIN_KEY);
    if (saved && BOOT_BG[saved]) skin = saved;
  } catch {
    // storage blocked: Noir
  }
  return BOOT_BG[skin];
};

export default function BootFallback() {
  return <div data-testid="v2-boot" style={{ position: "fixed", inset: 0, background: bootBackground() }} />;
}
